import { InfoCircleIcon } from '../icons'

const Tooltip = ({ text }) => (
    <div className="tooltip tooltip-normal p-1" style={{ display: 'inline' }}>
        <InfoCircleIcon className="text-gray-200" />
        <span className="tooltiptext tooltiptext-big">{text}</span>
    </div>
)

export default Tooltip
